import { render, staticRenderFns } from "./Workplace.vue?vue&type=template&id=cd4631de&scoped=true&"
import script from "./Workplace.vue?vue&type=script&lang=js&"
export * from "./Workplace.vue?vue&type=script&lang=js&"
import style0 from "./Workplace.vue?vue&type=style&index=0&id=cd4631de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4631de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd4631de')) {
      api.createRecord('cd4631de', component.options)
    } else {
      api.reload('cd4631de', component.options)
    }
    module.hot.accept("./Workplace.vue?vue&type=template&id=cd4631de&scoped=true&", function () {
      api.rerender('cd4631de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Workplace.vue"
export default component.exports